export default __webpack_public_path__ + "static/media/placeholder.ac9e386e.png";